import React, { Fragment } from 'react'
import { Team } from '@/payload-types'
import { GridBlock } from '@/components'

interface TeamListProps {
  items: Team[]
}

function TeamList({ items }: Readonly<TeamListProps>) {
  if (items.length === 0) return null

  return (
    <Fragment>
      {items.map((team) => {
        return (
          <Fragment key={team.id}>
            {team.people ? (
              <GridBlock
                blockType="grid"
                title={team.name}
                lead={team.lead}
                items={team.people.map((person) => ({
                  relationTo: 'people' as const,
                  value: person,
                }))}
              />
            ) : null}
          </Fragment>
        )
      })}
    </Fragment>
  )
}

export { TeamList }
